// extracted by mini-css-extract-plugin
export default {"link":"MenuItem_link__5G1C+","active":"MenuItem_active__nY13V","iconWrapper":"MenuItem_iconWrapper__P5OIL"};